import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import CheckStatus from "./CheckStatus";
import Refund from "./Refund";
import PartialRefund from "./PartialRefund";

const TransactionActions = () => (
    <Stack
        direction='row'
        px={2}
        pb={2}
        spacing={1}
        divider={(
            <Divider />
        )}
    >
        <CheckStatus />
        <Refund />
        <PartialRefund />
    </Stack>
);

export default TransactionActions;
